<ng-container [ngSwitch]="contexto.tipo">
  <ng-container *ngSwitchCase="'registrar'">
    <app-formulario-registrar-visita-offline
      *ngIf="contexto.row as r"
      [row]="r"
      (guardado)="onRegistrarGuardado()"
      (cerrarSolicitado)="cerrar()">
    </app-formulario-registrar-visita-offline>
  </ng-container>

  <div class="formulario-contenido-menu" *ngSwitchDefault>
    <div class="formulario-header">
      <div class="header-main-flex">
        <div class="header-titulos">
          <h2>{{ titulo }}</h2>
          <p class="subtitulo" *ngIf="subtitulo">{{ subtitulo }}</p>
        </div>
      </div>
      <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()" aria-label="Cerrar">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>

    <div class="formulario-content ruta-accion-panel-scroll">
      <div class="loading-container" *ngIf="cargando">
        <ion-spinner name="crescent"></ion-spinner>
        <p>Cargando…</p>
      </div>

      <ng-container *ngIf="!cargando">
        <!-- Caracterización -->
        <ng-container *ngIf="contexto.tipo === 'caracterizacion'">
          <div class="estado-historial estado-historial-error" *ngIf="!productor">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <p>No hay ficha de productor en datos locales. Sincronice la ruta del día con conexión.</p>
          </div>
          <ng-container *ngIf="productor as p">
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="person-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Nombre</span>
                <span class="valor">{{ nombreCompletoProductor(p) }}</span>
              </div>
            </div>
            <div class="campo-caract" *ngIf="p.rut">
              <span class="campo-icono"><ion-icon name="id-card-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">RUT</span>
                <span class="valor">{{ p.rut }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="business-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Unidad / Jerarquía</span>
                <span class="valor">{{ p.jerarquia.descripcion || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="location-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Comuna</span>
                <span class="valor">{{ p.comuna || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="mail-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Correo</span>
                <span class="valor">{{ p.email || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Última visita</span>
                <span class="valor">{{ p.ultima_visita || '—' }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Plan de negocio -->
        <ng-container *ngIf="contexto.tipo === 'plan'">
          <div class="estado-historial estado-historial-error" *ngIf="!plan">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <p>No hay plan de negocio vigente en datos locales para este productor.</p>
          </div>
          <ng-container *ngIf="plan as pl">
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="person-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Productor</span>
                <span class="valor">{{ pl.nombre }} {{ pl.primer_apellido || '' }} {{ pl.segundo_apellido || '' }}</span>
              </div>
            </div>
            <div class="campo-caract" *ngIf="pl.unidad_operativa">
              <span class="campo-icono"><ion-icon name="business-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Unidad operativa</span>
                <span class="valor">{{ pl.unidad_operativa }}</span>
              </div>
            </div>
            <div class="campo-caract" *ngIf="pl.rut">
              <span class="campo-icono"><ion-icon name="id-card-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">RUT</span>
                <span class="valor">{{ pl.rut }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="location-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Comuna</span>
                <span class="valor">{{ pl.comuna || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="mail-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Correo</span>
                <span class="valor">{{ pl.email || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Última visita</span>
                <span class="valor">{{ pl.ultima_visita || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract" *ngIf="textoCoordenadasPlan(pl) as coords">
              <span class="campo-icono"><ion-icon name="navigate-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Ubicación (lat., long.)</span>
                <span class="valor">{{ coords }}</span>
              </div>
            </div>

            <div class="estado-historial" *ngIf="!pl.plan_negocio">
              <ion-icon name="information-circle-outline"></ion-icon>
              <p>
                No hay un plan de negocio asociado en los datos guardados en el dispositivo. Si debería existir,
                sincronice la ruta del día con conexión.
              </p>
            </div>

            <ng-container *ngIf="pl.plan_negocio as pn">
              <div class="campo-caract">
                <span class="campo-icono"><ion-icon name="layers-outline"></ion-icon></span>
                <div class="campo-texto">
                  <span class="etiqueta">Etapa del plan</span>
                  <span class="valor">{{ etiquetaEtapaPlanNegocio(pl) }}</span>
                </div>
              </div>
              <div class="campo-caract">
                <span class="campo-icono"><ion-icon name="flag-outline"></ion-icon></span>
                <div class="campo-texto">
                  <span class="etiqueta">Estado del plan</span>
                  <span class="valor">{{ pn.estado?.trim() || '—' }}</span>
                </div>
              </div>
              <div class="campo-caract" *ngIf="pn.id_plan_negocio">
                <span class="campo-icono"><ion-icon name="finger-print-outline"></ion-icon></span>
                <div class="campo-texto">
                  <span class="etiqueta">Identificador del plan</span>
                  <span class="valor valor-texto-largo">{{ pn.id_plan_negocio }}</span>
                </div>
              </div>
              <div class="campo-caract" *ngIf="resumenUltimaSolicitudPlan(pl) as resSol">
                <span class="campo-icono"><ion-icon name="document-attach-outline"></ion-icon></span>
                <div class="campo-texto">
                  <span class="etiqueta">Solicitud de aprobación / reapertura</span>
                  <span class="valor valor-texto-largo">{{ resSol }}</span>
                </div>
              </div>
            </ng-container>

            <div class="plan-avance-bloque" *ngIf="filasAvancePlanCache.length > 0">
              <h3 class="plan-avance-titulo">Avance por sección (porcentaje)</h3>
              <div class="plan-avance-fila" *ngFor="let f of filasAvancePlanCache">
                <div class="plan-avance-fila-head">
                  <span class="plan-avance-etiqueta">{{ f.etiqueta }}</span>
                  <span class="plan-avance-pct">{{ f.pct }}%</span>
                </div>
                <div class="plan-avance-barra-wrap" aria-hidden="true">
                  <div class="plan-avance-barra" [style.width.%]="f.pct"></div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Ver detalles visita -->
        <ng-container *ngIf="contexto.tipo === 'detalles'">
          <div class="estado-historial estado-historial-error" *ngIf="!visita">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <p>No hay detalle de visita en datos locales. Sincronice la ruta del día.</p>
          </div>
          <ng-container *ngIf="visita as v">
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="pricetag-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Tipo</span>
                <span class="valor">{{ v.tipo || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="flag-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Estado</span>
                <span class="valor">{{ v.estado || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Fecha programada</span>
                <span class="valor">{{ v.fecha || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="location-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Lugar</span>
                <span class="valor">{{ v.lugar || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract">
              <span class="campo-icono"><ion-icon name="chatbubble-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Comentarios</span>
                <span class="valor valor-texto-largo">{{ v.comentarios || '—' }}</span>
              </div>
            </div>
            <div class="campo-caract" *ngIf="v.es_contingencia">
              <span class="campo-icono"><ion-icon name="warning-outline"></ion-icon></span>
              <div class="campo-texto">
                <span class="etiqueta">Emergencia</span>
                <span class="valor">{{ v.descripcion_emergencia || 'Sí' }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="formulario-footer" *ngIf="contexto.tipo !== 'registrar'">
      <ion-button fill="outline" (click)="cerrar()">Cerrar</ion-button>
    </div>
  </div>
</ng-container>
